import { useEffect } from 'react'

import { useScript } from '../../hooks/useScript'
import style from '../../styles/Weather/weather_radar_map'
import Title from './Title'

const WeatherRadarMap = ({ location }) => {
  const status = useScript(`https://widgets.media.weather.com/wxwidget.loader.js?cid=626796161`, {
    removeOnUnmount: true
  })

  useEffect(() => {
    if (status === 'loading') {
      window.wxWidgets = null
    }
  }, [status])

  return (
    <div className='radar-map-container'>
      <Title title='Radar Map' />
      <div className='map'>
        <wx-widget
          type='map'
          memberId='0013'
          mapId='0001'
          latitude={location?.lat?.toString()}
          longitude={location?.lon?.toString()}
          zoomlevel='12'
          fullscreen='true'
        />
      </div>
      <style jsx>{style}</style>
    </div>
  )
}
export default WeatherRadarMap
